<div class="col-12">
    <div class="row align-items-center">
        <img src="./assets/icons/arrow.svg">
        <span class="section-title ml-2">Saldo</span>
    </div>
    <div class="row mt-4">
        <div class="col-12 bloco-saldo">
            <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '5px', height: '35px', width: '65%', 'margin-bottom': 0 }" animation="progress-dark" *ngIf="isAvailableBalanceLoading"></ngx-skeleton-loader>
            <span class="saldo-label" *ngIf="!isAvailableBalanceLoading">{{(availableBalance > 0) ? (availableBalance | currency:'BRL':true) : "R$ 0,00"}}</span>
            <button (click)="adicionarCreditos()" class="botao-add">+Adicionar crédito</button>
            <br>
            <!-- matTooltip="Este valor contempla pedidos que foram criados, porém ainda estão pendentes de pagamento" matTooltipPosition="above" -->
            <span class="agendados-title mt-3"(click)="verDepositos()" >Pagamentos Pendentes</span>
            <br>
            <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '5px', height: '25px', width: '30%', 'margin-bottom': 0 }" animation="progress-dark" *ngIf="isDepositsTotalBalanceLoading"></ngx-skeleton-loader>
            <span class="agendados-label mt-2 mb-2" *ngIf="!isDepositsTotalBalanceLoading">{{(depositsTotalBalance > 0) ? (depositsTotalBalance | currency:'BRL':true) : "R$ 0,00"}}</span>
            <span (click)="verExtrato()" class="extrato-label">+Ver Extrato</span>
        </div>
    </div>
</div>
